import axios from 'axios';

const CORE_SERVICES_URL = '/api/core';
const AUTH_TOKEN = import.meta.env.VITE_CORE_SERVICES_AUTH_TOKEN;

const client = axios.create({
  baseURL: CORE_SERVICES_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    ...(AUTH_TOKEN && { 'Authorization': `Bearer ${AUTH_TOKEN}` }),
  },
});

// Add auth token if present
client.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('pkb_web_token');
  if (token && token.startsWith('Basic ')) {
    // Use the stored Basic Auth header
    config.headers['Authorization'] = token;
  }
  return config;
});

export const coreServicesApi = {
  praiseKink: {
    async uploadTemp(params: { image: string; userId?: string }) {
      const response = await client.post('/praise-kink/upload-temp', params);
      return response.data;
    },

    async processImage(params: {
      imageUrl: string;
      userId?: string;
      channelId?: string;
      guildId?: string;
      messageId?: string;
      sensitivity?: string;
    }) {
      const response = await client.post('/praise-kink/process-image', {
        imageUrl: params.imageUrl,
        userId: params.userId,
        channelId: params.channelId,
        guildId: params.guildId,
        messageId: params.messageId,
        sensitivity: params.sensitivity,
      });
      return response.data;
    },

    async analyzeImage(params: {
      imageUrl: string;
      userId?: string;
      channelId?: string;
      guildId?: string;
      sensitivity?: string;
    }) {
      const response = await client.post('/praise-kink/analyze-image', {
        imageUrl: params.imageUrl,
        userId: params.userId,
        channelId: params.channelId,
        guildId: params.guildId,
        sensitivity: params.sensitivity,
      });
      return response.data;
    },

    async generateLewdResponse(params: {
      description: string;
      discordUserId: string;
      channelId?: string;
      guildId?: string;
      conversationHistory?: any[];
      isGodMode?: boolean;
    }) {
      const response = await client.post('/praise-kink/generate/lewd', params);
      return response.data;
    },

    async generateRoastResponse(params: {
      description: string;
      discordUserId: string;
      channelId?: string;
      guildId?: string;
    }) {
      const response = await client.post('/praise-kink/generate/roast', params);
      return response.data;
    },
  },
};

export function handleApiError(error: any): string {
  if (error.response?.data?.error) {
    return error.response.data.error;
  }
  if (error.response?.data?.message) {
    return error.response.data.message;
  }
  if (error.message) {
    return error.message;
  }
  return 'An unknown error occurred';
}
